import { Button } from "@/components/ui/button";
import { cn } from "@/utils/cn";
import { UsersRound, LayoutGrid } from "lucide-react";

interface ViewOption {
  value: string;
  label: string;
}

interface ViewModeSelectorProps {
  options: ViewOption[];
  defaultValue?: string;
  onValueChange: (value: string) => void;
  triggerClassName?: string;
}

export default function ViewModeSelector({
  options,
  defaultValue,
  onValueChange,
  triggerClassName,
}: ViewModeSelectorProps) {
  const currentValue = defaultValue || options[0]?.value || "";

  // 현재 선택된 모드의 반대 모드 찾기
  const oppositeOption = options.find((opt) => opt.value !== currentValue);

  const handleToggle = () => {
    if (oppositeOption) {
      onValueChange(oppositeOption.value);
    }
  };

  // 표시할 아이콘 결정: 전체보기면 Grid, 팀별보기면 UsersRound
  const displayIcon =
    oppositeOption?.label === "전체보기" ? <LayoutGrid /> : <UsersRound />;

  return (
    <Button
      variant="outline"
      onClick={handleToggle}
      className={cn(
        triggerClassName,
        "bg-transparent! hover:border-zinc-400 rounded-full p-4.5 group"
      )}
      aria-label={oppositeOption?.label || "전환"}
    >
      {/* <div className="size-5 flex items-center justify-center">
        {displayIcon}
      </div> */}
      <span className="text-sm text-zinc-500 group-hover:text-zinc-700">
        {oppositeOption?.label || options[0]?.label || "전환"}
      </span>
    </Button>
  );
}
